"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _markdown = _interopRequireDefault(require("../markdown"));

var _linkBase = require("../link/link-base");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Message = (0, _styledComponents["default"])(_markdown["default"]).withConfig({
  displayName: "messsage-bannerstyles__Message",
  componentId: "sc-1k9adwb-0"
})(["grid-column:main-start / main-end;display:flex;justify-content:center;text-align:center;padding:4px 0;color:", ";&&&& a{", ";}"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return (0, _linkBase.linkVariants)(props)({
    variant: 'white'
  });
});
exports.Message = Message;